import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';

const testimonials = [
  {
    quote: "weBridge.ai doubled my appointment rate by responding to late-night Zillow leads instantly. I wake up to a full calendar now. And I didn't have to set up a single thing.",
    name: "Sarah Kim",
    title: "Top Producer, RE/MAX Calgary",
    avatar: "https://images.unsplash.com/photo-1770199105692-9e52ff137cad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjByZWFsJTIwZXN0YXRlJTIwYWdlbnQlMjBwb3J0cmFpdHxlbnwwfHx8fDE3NzQ5MzMyNDZ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    quote: "The AI sounds so natural that my leads don't even realize it's not me. It qualifies them perfectly and books right into my calendar.",
    name: "James Mitchell",
    title: "Broker, Royal LePage Benchmark",
    avatar: "https://images.pexels.com/photos/30004321/pexels-photo-30004321.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    quote: "I was losing 40% of my leads to slow response times. Since deploying weBridge, my conversion rate went from 3% to 11%.",
    name: "Aisha Lawal",
    title: "Agent, CIR Realty Calgary",
    avatar: null,
  },
  {
    quote: "Setup took 10 minutes on my end — the weBridge team handled everything else. Within the first week, the AI booked 7 showings I would have completely missed.",
    name: "Ryan Burke",
    title: "Team Lead, eXp Realty Alberta",
    avatar: null,
  },
];

function TestimonialCard({ testimonial }) {
  return (
    <div
      data-testid={`testimonial-${testimonial.name.toLowerCase().replace(/\s+/g, '-')}`}
      className="flex-shrink-0 w-[360px] lg:w-[420px] bg-neutral-900/40 border border-white/5 rounded-2xl p-8 mx-3"
    >
      {/* Stars */}
      <div className="flex gap-1 mb-4">
        {[1, 2, 3, 4, 5].map((s) => (
          <Star key={s} size={14} className="text-[#00E5FF] fill-[#00E5FF]" />
        ))}
      </div>

      <p
        className="text-base leading-relaxed text-neutral-300 mb-6"
        style={{ fontFamily: 'Manrope, sans-serif' }}
      >
        "{testimonial.quote}"
      </p>

      <div className="flex items-center gap-3">
        {testimonial.avatar ? (
          <img
            src={testimonial.avatar}
            alt={testimonial.name}
            className="w-10 h-10 rounded-full object-cover"
          />
        ) : (
          <div className="w-10 h-10 rounded-full bg-neutral-800 flex items-center justify-center text-xs text-neutral-400 font-medium">
            {testimonial.name.split(' ').map(n => n[0]).join('')}
          </div>
        )}
        <div>
          <p className="text-sm font-medium text-white">{testimonial.name}</p>
          <p className="text-xs text-neutral-500">{testimonial.title}</p>
        </div>
      </div>
    </div>
  );
}

export default function TestimonialsSection() {
  const doubledTestimonials = [...testimonials, ...testimonials];

  return (
    <section data-testid="testimonials-section" className="py-24 lg:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 mb-14">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
        >
          <span className="text-xs uppercase tracking-[0.2em] text-[#00E5FF] font-semibold block mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Testimonials
          </span>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-white"
            style={{ fontFamily: 'Outfit, sans-serif' }}
          >
            Calgary Top Producers Trust Us
          </h2>
        </motion.div>
      </div>

      {/* Marquee */}
      <div className="relative">
        <div className="flex animate-marquee">
          {doubledTestimonials.map((t, i) => (
            <TestimonialCard key={`${t.name}-${i}`} testimonial={t} />
          ))}
        </div>
        {/* Fade edges */}
        <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#050505] to-transparent z-10 pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#050505] to-transparent z-10 pointer-events-none" />
      </div>
    </section>
  );
}
